import React, { useState } from "react";
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert
} from "reactstrap";
import { useNavigate, useLocation } from "react-router-dom";

const VerifyOtp = () => {

  const navigate = useNavigate();
  const location = useLocation();

  const email = location.state?.email;

  const [otp, setOtp] = useState("");

  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");

  // const API = "http://localhost/qads_interview/auth/";
  const API = "https://interview.qads.co.in/qads_interview/auth/";

  const handleVerify = async (e) => {

    e.preventDefault();

    setMsg("");
    setError("");

    try {

      const res = await axios.post(
        API + "verify_otp.php",
        {
          email: email,
          otp: otp
        }
      );

      if (res.data.status) {

        const token = res.data.data.token;

        // token save
        localStorage.setItem("token", token);

        setMsg("Registration successful");

        setTimeout(() => {
          navigate("/select");
        }, 1500);

      } else {

        setError(res.data.message);

      }

    } catch (err) {

      setError(
        err.response?.data?.message ||
        "Server error"
      );

    }

  };

  return (

    <div className="auth-wrapper">
         <Row className="justify-content-center w-100">
    <Col md="5">
      <Card className="auth-card">
        <CardBody>
          <h3 className="auth-title">Verify OTP</h3>
          <p className="text-center">OTP sent to <b>{email}</b></p>

          {msg && <Alert color="success">{msg}</Alert>}
          {error && <Alert color="danger">{error}</Alert>}

          <Form onSubmit={handleVerify}>
            <FormGroup>
              <Label>Enter OTP</Label>
              <Input type="text" maxLength="6" value={otp} onChange={(e) => setOtp(e.target.value)} required />
            </FormGroup>

            <Button type="submit" className="w-100 auth-btn">
              Verify OTP
            </Button>
          </Form>
        </CardBody>
      </Card>
    </Col>
  </Row>
    </div>
 


  );

};

export default VerifyOtp;